import { createStore, createLogger } from 'vuex'
import jobApplications from './modules/job-applications'

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  modules: {
    jobApplications,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})